import { type FC, useState } from 'react';
import { Button, Form, Col, Modal } from 'react-bootstrap';

import { metadataItem } from './styles';

interface Props {
	metadata: { [key: string]: string };
	isShown: boolean;
	onHide: () => void;
	onMetadataUpdate: (_) => void;
}

const EditMetadataModal: FC<Props> = (props) => {
	const { metadata, isShown, onHide, onMetadataUpdate } = props;

	const [rows, setRows] = useState(Object.entries(metadata));

	const updateMetadataSubmit = () => {
		const elementMetadata = rows.reduce((acc, curr) => {
			return curr[0] === '' ? acc : { ...acc, [curr[0]]: curr[1] };
		}, {});

		onMetadataUpdate(elementMetadata);
		onHide();
	};

	const addItem = () => {
		setRows([...rows, ['', '']]);
	};

	const onKeyChange = (key, index) => {
		setRows([...rows.slice(0, index), [key, rows[index][1]], ...rows.slice(index + 1)]);
	};

	const onValueChange = (value, index) => {
		setRows([...rows.slice(0, index), [rows[index][0], value], ...rows.slice(index + 1)]);
	};

	return (
		<Modal show={isShown} onHide={onHide} centered onClick={(e) => e.stopPropagation()}>
			<Modal.Header closeButton>
				<Modal.Title>
					<div>Edit metadata</div>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Form>
					{rows.map((row: [string, string], i) => (
						<Form.Row className={metadataItem} key={i}>
							<Col sm={4}>
								<Form.Control
									placeholder="Key"
									defaultValue={row[0]}
									onChange={(e) => onKeyChange(e.target.value, i)}
								/>
							</Col>
							<Col>
								<Form.Control
									placeholder="Value"
									defaultValue={row[1]}
									onChange={(e) => onValueChange(e.target.value, i)}
								/>
							</Col>
						</Form.Row>
					))}

					<Button variant="light" onClick={addItem}>
						Add item
					</Button>
				</Form>
			</Modal.Body>

			<Modal.Footer>
				<Button variant="success" onClick={updateMetadataSubmit}>
					Update
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default EditMetadataModal;
